module.exports = __webpack_public_path__ + "static/media/irrigation.d9aa7ff9.svg";